import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueKonami from 'vue-konami'
import {DatocmsImagePlugin, DatocmsStructuredTextPlugin} from 'vue-datocms'
import VueMasonry from 'vue-masonry-css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueKonami)
Vue.use(DatocmsImagePlugin, DatocmsStructuredTextPlugin)
Vue.use(VueMasonry)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
